import { Link } from 'react-router-dom'
import { Container, Logo } from '../ui'
import { ROOT_PATH } from '../../config/rootPath'

export function PrelaunchHeader() {
  return (
    <header className="py-10" style={{ paddingTop: 'var(--spacing-10)', paddingBottom: 'var(--spacing-10)' }}>
      <Container>
        <nav className="relative z-50 flex justify-between">
          <div className="flex items-center md:gap-x-12">
            <Link to={ROOT_PATH} aria-label="Home">
              <Logo className="h-10 w-auto" variant="image" showText={true} size="lg" />
            </Link>
            <div className="hidden md:flex md:gap-x-6">
              <a 
                href="#details" 
                className="text-sm font-semibold leading-6"
                style={{ color: 'var(--color-text-primary)' }}
                onClick={(e) => {
                  e.preventDefault()
                  const element = document.getElementById('details')
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' })
                    window.history.pushState(null, '', '#details')
                  }
                }}
              >
                Details
              </a>
              <a 
                href="#early-access" 
                className="text-sm font-semibold leading-6"
                style={{ color: 'var(--color-text-primary)' }}
                onClick={(e) => {
                  e.preventDefault()
                  const element = document.getElementById('early-access')
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' })
                    window.history.pushState(null, '', '#early-access')
                  }
                }}
              >
                Early Access
              </a>
              <a 
                href="#faq" 
                className="text-sm font-semibold leading-6"
                style={{ color: 'var(--color-text-primary)' }}
                onClick={(e) => {
                  e.preventDefault()
                  const element = document.getElementById('faq')
                  if (element) {
                    element.scrollIntoView({ behavior: 'smooth' })
                    window.history.pushState(null, '', '#faq')
                  }
                }}
              >
                FAQs
              </a>
            </div>
          </div>
        </nav>
      </Container>
    </header>
  )
} 